import { useQuery } from "@tanstack/react-query";
import { tarefaService } from "@/services/api/tarefa.service";

/** Quem viu a conversa da tarefa e quando — alimenta o tooltip de "lido por" nas mensagens enviadas. */
export function useTarefaVisualizacoes(tarefaId: number) {
  const { data: visualizacoes = [] } = useQuery({
    queryKey: ["tarefa-visualizacoes", tarefaId],
    queryFn: () => tarefaService.getVisualizacoesByTarefaId(tarefaId),
    enabled: !!tarefaId,
    staleTime: 1000 * 30,
  });

  return { visualizacoes };
}
